import React from 'react';
import PropTypes from 'prop-types';

const OtoCountDown = props => {
  return <div id="normal-countdown">
    <div className="time-sec">
      <h3 className="main-time">{props.value}</h3> <span>{props.text}</span>
    </div>
  </div>
}

OtoCountDown.displayName = 'OtoCountDown';
OtoCountDown.propTypes = {
  text: PropTypes.string,
  value: PropTypes.number.isRequired,
};

export default OtoCountDown;
